import { useState, useEffect } from 'react';

/**
 * Debounce hook - მნიშვნელობის დაყოვნებით დაბრუნება
 * @param {any} value - მნიშვნელობა
 * @param {number} delay - დაყოვნება მს-ში (default: 300)
 * @returns {any} - debounced მნიშვნელობა
 */
export function useDebounce(value, delay = 300) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Cleanup - თუ value შეიცვალა, გავაუქმოთ წინა timer
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

/**
 * Debounced search hook - სპეციალურად ძიებისთვის
 * @param {string} initialValue - საწყისი მნიშვნელობა
 * @param {number} delay - დაყოვნება
 * @returns {[string, function]} - [debouncedValue, setValue]
 */
export function useDebouncedSearch(initialValue = '', delay = 300) {
  const [value, setValue] = useState(initialValue);
  const debouncedValue = useDebounce(value, delay);

  return [debouncedValue, setValue];
}
